import { Link } from "react-router-dom";

export default function Cta() {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto w-full max-w-7xl px-4 pb-14 md:px-8 md:pb-20">
        <div className="relative overflow-hidden rounded-xl bg-secondary-800 px-6 py-14 text-center md:px-12">
          <div className="absolute -right-8 -top-10 h-48 w-48 rounded-full bg-primary-500/30 blur-3xl" />
          <div className="absolute -bottom-12 -left-8 h-44 w-44 rounded-full bg-accent-500/25 blur-3xl" />
          <div className="relative z-10">
            <h2 className="text-2xl leading-snug text-background-50 md:text-4xl">
              选一种你喜欢的姿势，现在就开始看
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              翻页、下拉、目录跳转、夜间模式、缓存、横屏——随时切换，随时开看。
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/comics"
                className="flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
              >
                马上开看 <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/features"
                className="flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-100/30 px-6 py-3 text-sm font-semibold text-background-100 transition-colors hover:bg-background-100/10 sm:w-auto"
              >
                了解阅读功能
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}